import { QueryHookOptions } from '@apollo/client';
import { MeQuery, MeQueryVariables, useMeQuery } from '../../graphql/queries/user/generated/Me';

export default function useUser(baseOptions?: QueryHookOptions<MeQuery, MeQueryVariables>) {
  const { data, loading, error } = useMeQuery(baseOptions);
  return { me: data?.me || null, loading, error };
}
